<template>
  <div
    id="app"
    class="min-vh-100 flex flex-column w-full"
  >
    <upgrade-plan-bar v-if="authenticated && !subscriptionIsActive && !loading && ['dashboard', 'shared-projects'].includes($route.name)" />
    <reactivate-bar v-if="authenticated && pendingReactivation && !isLifetime && !loading && ['dashboard', 'shared-projects'].includes($route.name)" />
    <programmatically-confirmation-dialog />
    <router-view />

    <preloader />
    <alt-preloader />
    <progress-loader />

    <div class="w-full" />

    <the-footer
      v-if="!['login', 'reset-password', 'sign-up', 'project-invite', 'editor', 'modal.editor', 'mega-menu.editor', 'editor.post', 'module.blog', 'reactivate', 'signup', 'welcome', 'maintenance'].includes($route.name) && $route.name ? !$route.name.startsWith('editor.') : false"
      class="mt-auto"
    />

    <AgreementModal
      v-if="user"
      v-model="agreement"
      :user="user"
    />

    <!--    <error-modal-->
    <!--      v-for="(error,index) in errorsList"-->
    <!--      :key="index"-->
    <!--      :error="error"-->
    <!--    />-->
  </div>
</template>

<script>
// import Cookie from 'js-cookie'
import _ from 'lodash'
import {mapGetters, mapState} from 'vuex'
import Preloader from './components/utils/Preloader'
import AltPreloader from './components/utils/AltPreloader'
import ProgressLoader from './components/utils/ProgressLoader'
import TheFooter from './layouts/Footer.vue'
import ProgrammaticallyConfirmationDialog from '@/components/editor/modals/ProgrammaticallyConfirmationDialog.vue'
import AgreementModal from '@/components/modals/Agreement.vue'
import UpgradePlanBar from '@/components/alert-bar/subscription/UpgradePlanBar.vue'
// import ReactivateBar from '@/components/alert-bar/subscription/ReactivateBar.vue'

export default {
  name: 'App',
  components: {
    ProgrammaticallyConfirmationDialog,
    ProgressLoader,
    AltPreloader,
    Preloader,
    TheFooter,
    AgreementModal,
    UpgradePlanBar
    // ReactivateBar
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapGetters('auth', {
      authenticated: 'authenticated',
      subscriptionIsActive: 'subscriptionIsActive',
      pendingReactivation: 'pendingReactivation',
      isLifetime: 'isLifetime'
    }),
    errorsList () {
      return this.$store.state.notifications.errors
    }
  },
  data () {
    return {
      agreement: false,
      loading: true
    }
  },
  async created () {
    this.loading = true
    if (this.user) {
      const estage_agreement = !!this.user.estage_agreement
      if (!estage_agreement) {
        this.agreement = true
      } else {
        const agreement = JSON.parse(this.user.estage_agreement)
        if (!agreement.sep_24_2025) {
          this.agreement = true
        }
      }

      if (_.includes(['BUSINESS_PLUS_M', 'BUSINESS_PLUS_Y'], this.user.user_subscription?.plan?.code)) {
        this.$store.state.editor.businessPlusSubscription = true
      } else {
        axios.get('/api/user/profile')
          .then(({data}) => {
            this.$store.state.editor.businessPlusSubscription = data.data.business_plus
          })
      }
    }

    setTimeout(() => {
      this.loading = false
    }, 250)
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        const name = 'viewport'
        let $viewport = document.head.querySelector(`[name="${name}"]`)
        if (!$viewport) {
          $viewport = document.createElement('meta')
          $viewport.setAttribute('name', name)
          document.head.appendChild($viewport)
        }

        if (to.meta && to.meta.viewport) {
          // Pages that require fixed zoom (e.g., editors). Keep content valid; do not leave empty.
          $viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no')
        } else {
          // Sane default for the rest of the app; never clear to an empty string.
          $viewport.setAttribute('content', 'width=device-width, initial-scale=1.0')
        }

        // Defensive: clear any leftover global scroll locks from modals or previous routes
        if (document && document.body) {
          document.body.classList && document.body.classList.remove('modal-open')
          document.body.style && (document.body.style.overflow = '')
        }
        if (document && document.documentElement && document.documentElement.style) {
          document.documentElement.style.overflow = ''
        }
      }
    }
  }
}
</script>

<style lang="scss">
[data-lastpass-root] {
  transform: translateX(100%);
}

/* Improve horizontal scrolling behavior across browsers (iOS Safari, Chrome/Windows, etc.) */
.scroll-x {
  -webkit-overflow-scrolling: touch; /* iOS momentum scrolling */
  overscroll-behavior-x: contain;    /* prevent parent scroll chaining */
  touch-action: pan-x;               /* allow horizontal touch panning */
  scrollbar-gutter: stable both-edges; /* keep layout stable when scrollbars appear */
}

.scroll-y {
  overflow-y: auto;                 /* enable vertical scroll when needed */
  -webkit-overflow-scrolling: touch; /* iOS smooth scrolling */
  overscroll-behavior-y: contain;    /* stop scroll chaining */
  touch-action: pan-y;               /* allow vertical panning only */
  scrollbar-gutter: stable both-edges; /* keep layout stable when scrollbars appear */
}
</style>
